/*
 * AQS — force the hamburger drawer menu on desktop (homepage only).
 *
 * Vessel decides between the inline menu ('menu') and the hamburger drawer
 * ('drawer') via `header-component[data-menu-style]`, recomputed on load and
 * resize. We pin it to 'drawer' so the hamburger shows at every width, and a
 * MutationObserver re-asserts it whenever the theme recalculates.
 */
(function () {
  function getHeader() {
    return document.querySelector('header-component');
  }

  function forceDrawer() {
    var header = getHeader();
    if (header && header.dataset.menuStyle !== 'drawer') {
      header.dataset.menuStyle = 'drawer';
    }
  }

  function init() {
    var header = getHeader();
    if (!header) {
      // Custom element not upgraded yet — try again next frame.
      requestAnimationFrame(init);
      return;
    }

    forceDrawer();

    try {
      var observer = new MutationObserver(forceDrawer);
      observer.observe(header, {
        attributes: true,
        attributeFilter: ['data-menu-style'],
      });
    } catch (e) {
      /* MutationObserver unsupported — fall back to resize handling only. */
    }

    window.addEventListener('resize', forceDrawer, { passive: true });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
